import PropTypes from 'prop-types';
import React from 'react';
import { SeriesChart } from '~/modules/common/charts/dashboard';
import { useCostChartConfig } from '~/modules/common/charts/dashboard/config';
import { useCostChartData } from '~/modules/common/charts/hooks';
import { BarsChartLoading } from '~/modules/common/components/DetailsPage/Charts';
import { useProjectCosts } from './hooks/useProjectCosts';

export const CostsChart = ({ chartDataInput, titleId }) => {
  const { actualBarColor, gradientId, legends } = useCostChartConfig();
  const { loading, costCurrency, costSeriesData } = useProjectCosts({
    chartDataInput
  });
  const { actualDataPoints, estimatedDataPoints } = useCostChartData({
    costSeriesData,
    costCurrency
  });

  return loading ? (
    <BarsChartLoading />
  ) : (
    <SeriesChart
      name="projectCost"
      actualBarColor={actualBarColor}
      gradientId={gradientId}
      legends={legends}
      actualDataPoints={actualDataPoints}
      estimatedDataPoints={estimatedDataPoints}
      titleId={titleId}
    />
  );
};

CostsChart.propTypes = {
  chartDataInput: PropTypes.object,
  titleId: PropTypes.string
};

export default CostsChart;
